import zappy from "@zappy-ride/library.react.components";
import { FormVehicleStatsRow } from "./FormVehicleStatsRow";

export * from "./FormVehicleStatsRow";

zappy.FactoryInstance.registerComponent(FormVehicleStatsRow);
